var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "20.117 18.986 54.238 38.231",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 79.25
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "chevron_svg__a",
    x: 0,
    y: 0,
    width: 110,
    height: 90,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.6579 .65347 0 16.196 63.101)",
    filter: "url(#chevron_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon open-chevron-top",
    d: "M8.945 47.5L51.207 6l15.848 15.563L40.642 47.5l26.413 25.938L51.207 89 8.945 47.5z",
    fill: "#FBB03B"
  }))));
}

export default SvgChevron;